import { ScoreModelResource } from '../../../model/resources/scoreModelResource';
import { useController } from 'rest-hooks';
import { useScoreModel } from '../../../model/context/scoreModelContext';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const NewScoreModelButton = () => {

  const { switchScoreModel } = useScoreModel();
  const navigate = useNavigate();
  const location = useLocation();
  const { invalidate } = useController();
  const intl = useIntl();
  const changeSelectedScoreModel = () => {
    invalidate(ScoreModelResource.detail(), { scoreModelId: undefined });
    switchScoreModel( undefined);
  };

  if (location.pathname !== '/' && !location.pathname.startsWith('/scoremodel')) {
    return null;
  }

  return(
    <Button variant='contained'
            color='primary'
            sx={{marginTop:1}} onClick={() => {changeSelectedScoreModel(); navigate('/scoremodel');} }>
      {intl.formatMessage({ id: "NewScoreModelButton"})}
    </Button>
  );
}
export default NewScoreModelButton;